import React from "react";
import config from './../../config.js';
import Loading from './../../../components/loading.js';

export default class SearchSubject extends React.Component {
    constructor(props) {
        super(props);
        let user = {};
        if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
            user = JSON.parse(localStorage.user);
        }
        let search_list = props.search_list || {};
        this.state = {
            user: user,
            tags: [],
            series: [],
            modality_prototypes: [],
            search_list: search_list
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleModalityChange = this.handleModalityChange.bind(this);

    }

    componentDidMount() {
        this.initTags();
        this.initSeries();
    }

    componentWillReceiveProps(nextProps) {

    }

    handleInputChange(event) {
        this.props.handleInputSearch(event)
    }

    handleModalityChange(event) {
        const me = this;
        const target = event.target;
        const value = target.value;
        let { modality_prototypes, search_list } = me.state;
        let series = [];

        modality_prototypes.map((m, i) => {
            if (m.name == value) {
                series = m.list;
            }
            if (value == '') {
                search_list.series = '';
                series = series.concat(m.list);
            }
        });

        me.setState({
            search_list: search_list,
            series: series
        });
        me.props.handleInputSearch(event)
    }

    initSeries() {
        const me = this;
        const {
            user,
        } = me.state;

        const postdata = {
            userid: user.id,
            request: 'list',
            Authorization: localStorage.token
        };
        me.setState({
            loading: true
        });
        fetch(config.host + '/prototype/index', {
            method: 'post',
            body: JSON.stringify(postdata)
        })
            .then(res => res.json())
            .then(json => {
                //console.log(json);
                if (json.status === 1) {
                    let modality_prototypes = json.modality_prototypes;
                    let series = [];
                    modality_prototypes.map((m, i) => {
                        series = series.concat(m.list);
                    });
                    //console.log(series)
                    me.setState({
                        modality_prototypes: modality_prototypes,
                        series: series,
                        loading: false
                    });

                } else {
                    me.setState({
                        modality_prototypes: [],
                        loading: false
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    initTags() {
        const me = this;
        const {
            user,
        } = me.state;

        const postdata = {
            userid: user.id,
            request: 'list',
            Authorization: localStorage.token
        };
        me.setState({
            loading: true
        });
        fetch(config.host + '/tags/index', {
            method: 'post',
            body: JSON.stringify(postdata)
        })
            .then(res => res.json())
            .then(json => {
                console.log(json);
                if (json.status === 1) {
                    let data = json.data;
                    me.setState({
                        tags: data,
                        loading: false
                    });

                } else {
                    me.setState({
                        tags: [],
                        loading: false
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        let {
            tags,
            modality_prototypes,
            series,
            search_list
        } = this.state;
        //console.log(series)
        return (<div>
            <form >
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>受试者编号</label>
                        <input type="text" name="search_number" className="form-control" maxLength="128" placeholder="" onChange={this.handleInputChange} />
                    </div>
                    <div className="form-group col-md-4">
                        <label>年龄</label>
                        <input type="number" name="search_age" max="120" min="0" maxLength="3" className="form-control" placeholder="" onChange={this.handleInputChange} />
                    </div>
                    <div className="form-group col-md-4">
                        <label>性别</label>
                        <select name="search_gender" className="form-control" onChange={this.handleInputChange} value={search_list.gender}>
                            <option value="">无</option>
                            <option value="1">女</option>
                            <option value="0">男</option>
                        </select>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label>模态</label>
                        <select name="search_modality" className="form-control" onChange={this.handleModalityChange} value={search_list.modality}>
                            <option value="">无</option>
                            {
                                modality_prototypes.length > 0 && modality_prototypes.map((item, index) => {
                                    return <option value={item.name} key={index}>{item.name}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="form-group col-md-4">
                        <label>序列</label>
                        <select name="search_series" className="form-control" onChange={this.handleInputChange} value={search_list.series}>
                            <option value="">无</option>
                            {
                                series.length > 0 && series.map((s, i) => {
                                    return <option value={s} key={i}>{s}</option>
                                })
                            }
                        </select>
                    </div>
                    <div className="form-group col-md-4">
                        <label>标签</label>
                        <select name="search_tag" className="form-control" onChange={this.handleInputChange} value={search_list.tag}>
                            <option value="">无</option>
                            {
                                tags.length > 0 && tags.map((s, i) => {
                                    return (<option value={s.id} key={i}>{s.name}</option>)
                                })
                            }
                        </select>
                    </div>
                </div>
            </form>
        </div>)
    }

}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/search_subject.js